import {
  dismissProspectingBanner,
  hasDismissedProspectingBanner,
  isProspectingAnnouncementActive,
} from "@/lib/prospecting-announcement";
import { useUser } from "@clerk/react";
import { useState } from "react";

type ProspectingAnnouncementState = {
  /** The announcement is still running: the modal may open on its own. */
  isActive: boolean;
  /** The banner is on screen — running, and not closed by the user. */
  isBannerShown: boolean;
  dismissBanner: () => void;
};

/**
 * What the chat needs to lay out the prospecting announcement: whether it runs
 * at all, and whether its banner takes the 40px at the top of the page.
 *
 * The deadline is read once per render, without a timer: a page left open
 * across midnight keeps the banner until the next navigation, which is fine.
 */
export function useProspectingAnnouncement(): ProspectingAnnouncementState {
  const { user } = useUser();
  const userId = user?.id;
  const [dismissedFor, setDismissedFor] = useState<string | undefined>();

  const isActive = isProspectingAnnouncementActive();
  const isDismissed =
    dismissedFor === userId || hasDismissedProspectingBanner(userId);

  return {
    isActive,
    isBannerShown: isActive && !isDismissed,
    dismissBanner: () => {
      dismissProspectingBanner(userId);
      setDismissedFor(userId);
    },
  };
}
